import React from "react";

import Modal from "../Modal";
import PixelFire from "./PixelFire";
import { trackAmplitudeEvent } from "../../amplitude";

export default class StreakSaveAppliedModal extends React.Component {
  daysAway() {
    return this.props.daysSinceLastSession ? this.props.daysSinceLastSession - 1 : 1;
  }

  componentDidMount() {
    trackAmplitudeEvent("streak_save_consumed", {
      save_balance_before: this.props.currentBalance + this.daysAway(),
      save_balance_after: this.props.currentBalance,
      days_since_last_session: this.props.daysSinceLastSession,
    });
    if (this.props.ackUrl && this.props.savedDate) {
      $.ajax({
        url: this.props.ackUrl,
        method: "POST",
        data: { type: "save", saved_date: this.props.savedDate },
      });
    }
  }

  onAwesomeClick() {
    trackAmplitudeEvent("streak_save_modal_tapped", { screen_type: "save" });
    this.modal.hide();
  }

  render() {
    return (
      <Modal
        id="streak-save-applied-modal"
        ref={(el) => this.modal = el}
        size="small"
        title="Streak Saved!"
        onHidden={this.props.onHidden}
      >
        <div className="text-center" style={{ padding: "8px 12px 4px" }}>
          <div style={{ marginBottom: 20, display: "flex", justifyContent: "center" }}><PixelFire size={88} /></div>
          <h3 style={{ marginTop: 0, marginBottom: 12 }}>Your streak was saved!</h3>
          <p style={{ color: "#5a5a5a", marginBottom: 28 }}>
            {this.daysAway() > 1
              ? `We noticed you were away for ${this.daysAway()} days, but we've got your back.`
              : "We noticed you were away yesterday, but we've got your back."}
          </p>
          <div className="joystix" style={{ alignItems: "baseline", display: "flex", gap: 8, justifyContent: "center", marginBottom: 28 }}>
            <span style={{ fontSize: 32 }}>{this.props.currentStreakDays}</span>
            <span style={{ color: "#868686" }}>day streak</span>
          </div>
          <button className="btn btn-success btn-block joystix btn-lg" onClick={() => this.onAwesomeClick()}>
            Awesome!
          </button>
        </div>
      </Modal>
    );
  }
}
